<!--
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-01-24 10:20:54
 * @Description: 
-->
<template>
    <img
        :src="globalStore.client ? cachedImageUrl : ''"
        class="coin-img flex pointer-events-none select-none"
        :class="{loading: !hasLoaded || !cachedImageUrl}"
        @load="fnLoaded"
        alt=""
    />
</template>

<script setup lang="ts">
import useSettingsStore from '~/stores/settings';
import { useCryptosImages } from '~/utils/fileImport';
import useGlobalStore from '@/stores/global';
import { useImageCache } from '~/composables/useImageCache';

const globalStore = useGlobalStore();
const { getCachedImage, preloadImage } = useImageCache();

const props = defineProps({
    name: {
        type: String,
    },
    size: {
        // 图标尺寸
        type: String,
        default: '20px',
    },
});

const cryptosImages = useCryptosImages();
const settingStore = useSettingsStore();
const hasLoaded = ref(false);
const cachedImageUrl = ref<string>('');

// ▼取得当前币种的图标路径
const curretCurrency = computed(() => {
    const coinName = props.name || settingStore.pickedCurrency;
    return cryptosImages[coinName] || '';
});

// 监听币种变化，更新缓存的图片 URL
watch(
    [curretCurrency, () => globalStore.client],
    async ([newCurrency]) => {
        if (!globalStore.client || !newCurrency) {
            cachedImageUrl.value = '';
            return;
        }
        
        try {
            // 使用缓存机制获取图片 URL
            cachedImageUrl.value = await getCachedImage(newCurrency);
        } catch (error) {
            // 降级到原始 URL
            cachedImageUrl.value = newCurrency;
        }
    },
    { immediate: true }
);

const fnLoaded = (ev)=>{
    const src = ev?.target?.src;
    // console.log('币种图已经加载', src); 
    hasLoaded.value = Boolean(src);
};

</script>

<style scoped lang="scss">
.coin-img {
    min-width: v-bind('size');
    width: v-bind('size'); // 接受 props 控制
    height: v-bind('size');
    &.loading{
        border-radius: 50%;
        content: linear-gradient(#0000, #0000); // 防止出现死图形态 
        background: linear-gradient(
            120deg,
            rgba(242, 242, 242, 0.8) 15%,
            rgba(217, 217, 217, 0.8) 50%,
            rgba(242, 242, 242, 0.8) 20%
        );
        background-size: 380% 100%;
        animation: skeleton-loading alternate 0.5s linear infinite;
    }
}

@keyframes skeleton-loading {
    0% {
        opacity: 0.7;
    }
    100% {
        opacity: 1;
    }
}

</style>
